export default __webpack_public_path__ + "static/media/rancher.210047a9.svg";